
























































































import {computed, ComputedRef, defineComponent, onMounted, ref, WritableComputedRef} from "@vue/composition-api"
import {useActions, useGetters} from "vuex-composition-helpers"
import {isoToDate} from "@/shared/filters/dates"
import datepicker from 'js-datepicker'
import {PeriodDate, PeriodValue} from "@/apps/StudentExchangeNonPartnerWidget/models/period-enums"
import {Period} from "@/apps/StudentExchangeNonPartnerWidget/models/store-viewmodel"
import ExchangeCard from "@/shared/components/molecules/ExchangeCardMolecule.vue"
import ErrorMessage from "@/shared/components/atoms/ErrorMessageAtom.vue"

export default defineComponent({
    name: "ExchangePeriod",
    components: {ErrorMessage, ExchangeCard},
    setup() {
        const {
            getPeriodIsInvalid, 
            getLanguage, 
            getLabels, 
            getPeriod, 
            isEditable
        } = useGetters([
            'getPeriodIsInvalid', 
            'getLanguage', 
            'getLabels', 
            'getPeriod', 
            'isEditable'
        ])
        const {
            setPeriod
        } = useActions([
            'setPeriod'
        ])
        
        const period: WritableComputedRef<Period> = computed({
            get(): Period {
                return getPeriod.value
            },
            set(value: Period): void {
                setPeriod(value)
            }
        })
        
        const disabled: ComputedRef<boolean> = computed(() => !isEditable.value)
        const periodIsInValid: ComputedRef<boolean> = computed(() => getPeriodIsInvalid.value)
        
        function buildDatePicker(): void {
            interface LooseObject {
                [key: string]: any
            }

            let dateOption: LooseObject = {
                formatter: (input: any, date: any) => {
                    input.value = isoToDate(date)
                },
                onSelect: (instance: any, date: any) => {
                    handleInput(instance.el.name, isoToDate(date))
                }
            }
            
            if (getLanguage.value == 'nl') {
                dateOption.overlayPlaceholder = 'Kies een jaar'
                dateOption.overlayButton = 'Verstuur'
                dateOption.customDays = ['Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za', 'Zo']
                dateOption.customMonths = ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December']
            }

            /**
             * we have to call the datepicker twice as it fails to select multiple inputs
             */
            datepicker('.vuw-date-picker-from', dateOption)
            datepicker('.vuw-date-picker-end', dateOption)
        }

        function handleInput(type: PeriodValue, value: any) {
            switch (type) {
                case PeriodValue.START:
                    period.value = {
                        completed: false,
                        start: value,
                        end: period.value.end,
                        reason: period.value.reason
                    }
                    break
                case PeriodValue.END:
                    period.value = {
                        completed: false,
                        start: period.value.start,
                        end: value,
                        reason: period.value.reason
                    }
                    break
                case PeriodValue.REASON:
                    period.value = {
                        completed: false,
                        start: period.value.start,
                        end: period.value.end,
                        reason: value
                    }
                    break
            }
        }

        onMounted(async () => {
            buildDatePicker()
        })
        
        return {
            period,
            disabled,
            getLabels,
            PeriodDate,
            PeriodValue,
            isEditable,
            handleInput,
            periodIsInValid
        }
    }
})
